module.exports = __webpack_public_path__ + "static/img/white_KCC-05.0ed6a91b.png";